import AuthBackground from '../../../assets/images/auth-bg.webp'

const AuthBackgroundImage = AuthBackground

export default AuthBackgroundImage
